import { IQueryContext } from 'framework/context/IQueryContext';
import { IQueryResultWithMetadata, IRosaPatientRecord, IRosaPatientRecordsQueryParams, IRosaPatientsQueryMetadata } from 'gen/ApiClient';
import React from 'react';

export const RosaPatientRecordsQueryContext = React.createContext<
	IQueryContext<IQueryResultWithMetadata<IRosaPatientRecord, IRosaPatientsQueryMetadata>, IRosaPatientRecordsQueryParams>
>(undefined as any);
